__turbopack_context__.v({
  "left-content": "kORvAa_left-content",
  "right-content": "kORvAa_right-content",
  "section": "kORvAa_section",
});
